import { useTokenStore } from "@/store/use-token-store";
import { NavigationGuardNext, RouteLocationNormalized } from "vue-router";

export const onCheckLogin = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  const $tokenStore = useTokenStore();
  if (!$tokenStore.accessToken) {
    next("/sign-in");
    return;
  }

  if (to.path === "/") {
    next("/call/list");
    return;
  }

  next();
};
